module.exports = __webpack_public_path__ + "img/three.33cbe70a.png";